import {createApp} from 'vue'
import App from './App.vue'
import router from './router';
import i18n from './i18n';
import {createPinia} from 'pinia'

import {IonicVue} from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/brands.css";
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/regular.css";

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */
/* @import '@ionic/vue/css/palettes/dark.always.css'; */
/* @import '@ionic/vue/css/palettes/dark.class.css'; */
// import '@ionic/vue/css/palettes/dark.system.css';
/* Theme variables */
import './theme/variables.css';
import './theme/ionicStyleOverrides.css';
import './theme/styles.css';

import {defineCustomElements} from '@ionic/pwa-elements/loader';
import {SplashScreen} from '@capacitor/splash-screen';
import {initNotificationStore} from '@/stores/notificationStore';

defineCustomElements(window);

const pinia = createPinia();

const app = createApp(App)
    .use(IonicVue)
    .use(router)
    .use(i18n)
    .use(pinia);

const initApp = async () => {
    // Simulate assets and data loading
    await new Promise(resolve => setTimeout(resolve, 2000));

    // Restore persisted notification state before the router processes
    // its first navigation — guarantees the guard can see pendingNotification
    await initNotificationStore();

    const { Capacitor } = await import('@capacitor/core');
    const { StatusBar, Style } = await import('@capacitor/status-bar');

    // TODO: remove this once we have a proper dark mode solution
    if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setOverlaysWebView({ overlay: true });
        await StatusBar.setStyle({ style: Style.Light });
    }

    await router.isReady();
    app.mount('#app');

    // Hide the splash screen after the app is mounted and ready
    await SplashScreen.hide();
};

initApp();